"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALES = void 0;
exports.LOCALES = ["tr", "en"];
//# sourceMappingURL=types.js.map